<div class="flex flex-col gap-1 w-full relative">
    <label class="text-[0.65rem] font-medium text-gray-500 uppercase tracking-wider mb-1">
        {{lebal}} <span *ngIf="is_required" class="text-red-500">*</span>
        <span *ngIf="accept === '.csv' || accept === '.pdf'" class="text-primary underline cursor-pointer ml-2" (click)="downloadTemplate()">Download
            Template</span>

    </label>

    <div class="flex flex-col gap-2">
        <!-- Minimal Upload Button -->
        <label *ngIf="multiple || images.length === 0"
            class="flex items-center justify-center px-4 py-4 bg-white border border-gray-300 rounded-md shadow-sm cursor-pointer hover:bg-gray-50 transition-all duration-200 group">
            <input [disabled]="disabled || paramValue.view == 'true'" [accept]="accept" type="file"
                [multiple]="multiple" (change)="onImageSelected($event)" class="hidden" />
            <div class="flex flex-col items-center gap-1 text-gray-600 group-hover:text-[#3F41D1]">
                <div class="flex items-center gap-2">
                    <i class='bx bx-cloud-upload text-xl'></i>
                    <span class="text-sm font-medium">Choose {{ accept.includes('image') ? 'Image' : 'File' }}</span>
                    <span class="text-[0.65rem] text-gray-400">(Supported: {{ accept }})</span>
                </div>
            </div>
        </label>

        <!-- Minimal File List -->
        <div *ngIf="images.length > 0" class="flex flex-col gap-2">
            <div *ngFor="let img of images; let i = index"
                class="flex items-center justify-between p-2 bg-gray-50 border border-gray-200 rounded-md">
                <div class="flex items-center gap-3 overflow-hidden">
                    <!-- Preview Icon/Image -->
                    <div
                        class="w-8 h-8 flex-shrink-0 rounded bg-gray-200 flex items-center justify-center overflow-hidden">
                        <img *ngIf="accept.includes('image') || accept.includes('.jpg') || accept.includes('.png') || accept.includes('.jpeg') || accept.includes('.webp')"
                            [src]="img" class="w-full h-full object-cover">
                        <i *ngIf="!(accept.includes('image') || accept.includes('.jpg') || accept.includes('.png') || accept.includes('.jpeg') || accept.includes('.webp'))"
                            class='bx bx-file text-gray-500 text-lg'></i>
                    </div>

                    <!-- File Info (Truncated) -->
                    <div class="flex flex-col min-w-0">
                        <span class="text-xs font-medium text-gray-700 truncate block max-w-fit">
                            {{ imageNames[i] || 'Uploaded File ' + (i + 1) }}
                        </span>
                        <span class="text-[0.65rem] text-gray-500">
                            {{ imageSizes[i] || 'Size unknown' }}
                        </span>
                    </div>
                </div>

                <!-- Delete Action -->
                <!-- Actions -->
                <div class="flex items-center gap-1">
                    <button type="button" (click)="view_image(i)"
                        class="p-1 text-gray-400 hover:text-primary rounded-full hover:bg-blue-50 transition-colors">
                        <i *ngIf="!(accept.includes('image') || accept.includes('.jpg') || accept.includes('.png') || accept.includes('.jpeg') || accept.includes('.webp'))"
                            class='bx bx-arrow-to-bottom text-lg'></i>
                        <i *ngIf="(accept.includes('image') || accept.includes('.jpg') || accept.includes('.png') || accept.includes('.jpeg') || accept.includes('.webp'))"
                            class='bx bx-show text-lg'></i>
                    </button>
                    <button *ngIf="!disabled && paramValue.view != 'true'" (click)="removeImage(i)"
                        class="p-1 text-gray-400 hover:text-red-500 rounded-full hover:bg-red-50 transition-colors">
                        <i class='bx bx-trash text-lg'></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="control && control.errors && (control.dirty || control.touched)" class="mt-1">
    <p class="text-xs text-red-500" *ngIf="control.errors.required">{{lebal}} is required.</p>
</div>